import React, { FunctionComponent } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { GQLPostsQuery } from '../generated/graphql'
import SvgLogo from '../generated/svg/logo'
import { formatDate } from '../utils/format-date'

const Outer = styled(Link)`
  overflow: hidden;
  @media (max-width: 40rem){
    & + & {
      border-top: 1px solid #aaa;
      margin-top: 2rem;
      padding-top: 2rem;
    } 
  }
`

const ThumbnailOuter = styled.div`
`

const ThumbnailProxy = styled.div`
  background-color: #fff;
  width: 100%;
  aspect-ratio: 3 / 2;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 40rem){
    aspect-ratio: 2.35 / 1;
  }
  svg {
    width: 60%;
    height: auto;
    display: block;
  }
`

const Thumbnail = styled.img`
  display: block;
  object-fit: cover;
  width: 100%;
  height: auto;
  aspect-ratio: 3 / 2;
  @media (max-width: 40rem){
    aspect-ratio: 2.35 / 1;
  }
` 

const DetailOuter = styled.div`
  margin-top: 1rem;
  display: flex;
  gap: 0.75rem;
  width: 100%;
`

const Initial = styled.div`
  font-size: 2.5rem;
  font-weight: 700;
`

const TextOuter = styled.div`
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

const Title = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 0.9rem;
  ${Outer}:hover & {
    text-decoration: underline;
  }
`

const Timestamp = styled.div`
  font-size: 0.9rem;
`

type BlogArticleItemProps = {
  post: NonNullable<NonNullable<NonNullable<GQLPostsQuery['posts']>['nodes']>[number]>
}
export const BlogArticleItem: FunctionComponent<BlogArticleItemProps> = ({post}) => {
  return <Outer to={`/blog/${post.postId}`}>
    <ThumbnailOuter>
      {
        post.featuredImage?.node?.mediaItemUrl ?
        <Thumbnail src={post.featuredImage?.node?.mediaItemUrl} width="300" height="200" /> :
        <ThumbnailProxy>
          <SvgLogo />
        </ThumbnailProxy>
      }
    </ThumbnailOuter>
    <DetailOuter>
      <Initial style={{color: post.categories?.nodes?.[0]?.fields?.color ?? 'inherit'}}>
        {post.categories?.nodes?.[0]?.fields?.initial}
      </Initial>
      <TextOuter>
        <Title>{post.title}</Title>
        <Timestamp>{formatDate(new Date(post.date ?? NaN))}</Timestamp>
      </TextOuter>
    </DetailOuter>
  </Outer>
}